import { Link } from 'react-router-dom';
import { useCartStore } from '../store/useCartStore';
import FallbackImage from '../components/FallbackImage';

export default function CartPage() {
  const { items, updateQuantity, removeItem } = useCartStore();
  const subtotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);

  if (items.length === 0) {
    return (
      <main className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="text-2xl font-bold text-[var(--foreground)] mb-4">
          Your Cart
        </h1>
        <p className="text-gray-500 mb-4">Your cart is empty.</p>
        <Link
          to="/shop"
          className="inline-block py-2 px-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700"
        >
          Continue shopping
        </Link>
      </main>
    );
  }

  return (
    <main className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-[var(--foreground)] mb-6">
        Your Cart
      </h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-4">
          {items.map((item) => (
            <div
              key={`${item.id}-${JSON.stringify(item.specification)}`}
              className="flex gap-4 p-4 border border-gray-200 dark:border-gray-800 rounded-lg"
            >
              <FallbackImage
                src={item.image}
                alt=""
                className="w-24 h-24 object-cover rounded"
              />
              <div className="flex-1 min-w-0">
                <p className="font-medium text-[var(--foreground)]">{item.name}</p>
                <p className="text-gray-500">PKR {item.price.toLocaleString()}</p>
                <div className="flex items-center gap-2 mt-2">
                  <button
                    type="button"
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    className="w-8 h-8 rounded border border-gray-300 dark:border-gray-600"
                  >
                    −
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    type="button"
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    className="w-8 h-8 rounded border border-gray-300 dark:border-gray-600"
                  >
                    +
                  </button>
                  <button
                    type="button"
                    onClick={() => removeItem(item.id)}
                    className="ml-4 text-sm text-red-600 hover:underline"
                  >
                    Remove
                  </button>
                </div>
              </div>
              <p className="font-semibold text-[var(--foreground)]">
                PKR {(item.price * item.quantity).toLocaleString()}
              </p>
            </div>
          ))}
        </div>
        <div className="lg:col-span-1">
          <div className="p-4 border border-gray-200 dark:border-gray-800 rounded-lg sticky top-24">
            <h2 className="font-semibold text-[var(--foreground)] mb-4">
              Order Summary
            </h2>
            <div className="flex justify-between mb-2">
              <span className="text-gray-500">Subtotal</span>
              <span>PKR {subtotal.toLocaleString()}</span>
            </div>
            <Link
              to="/checkout"
              className="block w-full py-3 text-center bg-orange-600 text-white rounded-lg font-medium hover:bg-orange-700 mt-4"
            >
              Proceed to Checkout
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
